import React, {useEffect, useState} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import axios from "axios";
import {useDispatch, useSelector} from "react-redux";
import {serviceActions} from "./store/service";
import {Card, CardBody, IconButton, Textarea, Typography, Button} from "@material-tailwind/react";
import {AlertTriangle, FileText, Wrench} from "lucide-react";
import Footer from "./footer";
import SummaryPanel from "./SummaryPanel";
import MobileNextButton from "./MobileNextButton";

function Services() {
    const navigate = useNavigate();
    const [serviceList, setServiceList] = useState(null);
    const [branch, setBranch] = useState(null);
    const [lastServiceChecked, setLastServiceChecked] = useState(false);
    const [lastServiceIndex, setLastServiceIndex] = useState(-1);
    const [selectedMemo, setSelectedMemo] = useState("");
    const [count, setCount] = useState(0);
    const [searchParams, setSearchParams] = useSearchParams();
    const [isEtcServiceSelected, setIsEtcServiceSelected] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    //const nextUrl = "/schedule";
    const [rightProps, setRightProps] = useState({
        nextUrl: "/schedule",
        ready: false,
    });

    const getServices = async () => {
        //localStorage.clear();
        try {
            await axios
                .get(process.env.REACT_APP_API_URL + "/api/v1/serviceList", {
                    withCredentials: true,
                })
                .then((response) => {
                    setServiceList(response.data);
                })
                .catch((error) => {
                    console.log(error);
                    navigate("/");
                });
        } catch (e) {
            console.log(e);
        }
    };

    const getAddress = async () => {
        //localStorage.clear();
        try {
            await axios
                .get(process.env.REACT_APP_API_URL + "/api/v1/getAddress", {
                    withCredentials: true,
                })
                .then((response) => {
                    setBranch(response.data);
                })
                .catch((error) => {
                    console.log(error);
                    navigate("/");
                });
        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        getServices();
        getAddress();
    }, []);

    const selectedService = (event) => {
        event.preventDefault();
        serviceList.map((service) => {
            if (service.id == event.target.value) {
            }
        });
    };

    const dispatch = useDispatch();
    const serviceArrayList = useSelector((state) => state.service);

    //서비스 목록을 클릭 했을 때 작동. 기타 버튼은 제외.
    const serviceAddHandler = (service) => {
        //get all checkboxes
        const checkboxes = document.getElementsByName("serviceList");
        const checkboxLen = checkboxes.length;
        const params = new URLSearchParams(searchParams);

        //마지막 기타가 선택되어 있다면 버튼 비활성화 시킨다.
        if (lastServiceChecked) {
            checkboxes[checkboxLen - 1].checked = false;
            dispatch(serviceActions.removeService(serviceArrayList.length - 1));
            params.delete("etc");
            setSearchParams(params.toString());
            setLastServiceChecked(false);
        }

        //동일한 버튼을 클릭 했을경우 인덱스 번호 획득
        let existsIndex = -1;
        for (let i = 0; i < serviceArrayList.length; i++) {
            if (serviceArrayList[i].id == service.id) {
                existsIndex = i;
            }
        }

        //동일한 서비스 목록이 state에 있었다면 제거하고, 아니면 새로 입력.
        if (existsIndex > -1) {
            dispatch(serviceActions.removeService(existsIndex));
            params.delete("service" + service.id);
            setSearchParams(params.toString());
            setRightProps({nextUrl: "/schedule", ready: false});
        } else {
            dispatch(serviceActions.addService(service));
            searchParams.set("service" + service.id, service.id);
            setSearchParams(searchParams);
            setRightProps({nextUrl: "/schedule", ready: true});
        }
    };

    //기타 버튼을 클릭 했을 때 작동
    const serviceAddHandlerETC = (service) => {
        //모든 쿼리 스트링 삭제.
        const params = new URLSearchParams(searchParams);
        searchParams.forEach((value, key) => {
            params.delete(key);
        });
        setSearchParams(params.toString());

        if (lastServiceChecked) {
            setLastServiceChecked(false);
        } else {
            setLastServiceChecked(true);
        }

        const checkboxes = document.getElementsByName("serviceList");
        const checkboxLen = checkboxes.length;

        //make other checkboxs false
        for (var i = 0; i < checkboxLen - 1; i++) {
            checkboxes[i].checked = false;
        }

        checkboxes[checkboxLen - 1].checked = true; //마지막 기타만 체크.

        dispatch(serviceActions.removeAll());
        dispatch(serviceActions.addService(service));
        searchParams.forEach((value, key) => {
        });
    };

    const [selectedServiceList, setSelectedServiceList] = useState([]);

    const ServiceListHandler = (event) => {
        const obj = JSON.parse(event.target.value);

        const checkboxes = document.getElementsByName("serviceList");
        const checkboxLen = checkboxes.length;

        setIsEtcServiceSelected(false);

        if (obj.type == "D") {
            setIsEtcServiceSelected(true);
            setSelectedMemo('');
            //make other checkboxs false
            for (var i = 0; i < checkboxLen - 1; i++) {
                checkboxes[i].checked = false;
            }

            checkboxes[checkboxLen - 1].checked = true; //마지막 기타만 체크.
            setLastServiceIndex(obj.id);

            const list = [];
            list.push(obj);
            setSelectedServiceList([...list]);
            localStorage.setItem("services", JSON.stringify([...list]));
        } else {
            checkboxes[checkboxLen - 1].checked = false; //마지막 기타만 체크 해제


            const list = selectedServiceList;
            let isSliced = false;
            for (let i = 0; i < list.length; i++) {
                if (list[i].type == "D") {
                    list.splice(i, 1);
                } else if (list[i].id === obj.id) {
                    list.splice(i, 1);
                    isSliced = true;

                    let serviceValue = searchParams.get("service");
                    let newValue = "";
                    if (lastServiceIndex > -1) {
                        setLastServiceIndex(-1);
                    }
                }
            }

            if (!isSliced) {
                list.push(obj);
            }

            setSelectedServiceList([...list]);
            localStorage.setItem("services", JSON.stringify([...list]));
            localStorage.removeItem("memo");
        }
    };

    const memoHandler = (event) => {
        setSelectedMemo(event.target.value);
        localStorage.setItem("memo", JSON.stringify(event.target.value));
        setCount(event.target.value.length);
    };

    return (
        <>
            <div className="flex flex-col min-h-screen bg-gradient-to-br from-blue-50 to-gray-50 scroll-container" style={{WebkitOverflowScrolling: 'touch', overscrollBehavior: 'none'}}>
                <div className="container mx-auto max-w-7xl px-4 py-4 sm:py-6 flex-1">
                    {/* Enhanced Header with back button */}
                    <div className="mb-6 sm:mb-8">
                        <div className="flex items-start sm:items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
                            <IconButton
                                variant="outlined"
                                color="blue-gray"
                                size="lg"
                                onClick={() => navigate("/")}
                                className="border-gray-300 hover:bg-gray-50 transition-all duration-300 flex-shrink-0 mt-1 sm:mt-0"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={2}
                                    stroke="currentColor"
                                    className="w-5 h-5 sm:w-6 sm:h-6"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"
                                    />
                                </svg>
                            </IconButton>
                            <div className="flex-1 min-w-0">
                                <Typography variant="h4" color="blue-gray"
                                            className="font-bold text-xl sm:text-2xl lg:text-3xl leading-tight">
                                    Select Services
                                </Typography>
                                <Typography variant="paragraph" color="gray" className="mt-1 text-sm sm:text-base lg:text-lg leading-relaxed">
                                    Choose the services you need
                                </Typography>
                            </div>
                        </div>

                        {/* Progress indicator */}
                        <div className="flex items-center justify-center mb-6 sm:mb-8 overflow-x-auto px-2 sm:px-4 overflow-y-hidden">
                            <div className="flex items-center justify-between w-full max-w-4xl">
                                {/* Step 1 - Select Services (CURRENT) */}
                                <div className="flex items-center justify-center relative">
                                    <div className="relative">
                                        {/* Pulsing ring animation - hidden on mobile */}
                                        <div className="absolute inset-0 w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-blue-500 rounded-full animate-ping opacity-20 hidden sm:block"></div>
                                        <div className="absolute inset-0 w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-blue-500 rounded-full animate-pulse opacity-30 hidden sm:block"></div>

                                        {/* Main step indicator */}
                                        <div className="relative w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-gradient-to-br from-blue-500 to-blue-600 text-white rounded-full flex items-center justify-center text-sm sm:text-base md:text-lg font-bold shadow-lg border-2 sm:border-4 border-white flex-shrink-0 z-10">
                                            1
                                        </div>
                                    </div>

                                    {/* Current step indicator - hidden on mobile */}
                                    <div className="ml-2 sm:ml-3 hidden sm:block">
                                        <Typography variant="small"
                                                    className="font-bold text-blue-600 text-sm sm:text-base whitespace-nowrap">
                                            Services
                                        </Typography>
                                        <div className="text-xs text-blue-500 font-medium">
                                            Current Step
                                        </div>
                                    </div>
                                </div>

                                {/* Connector line 1 */}
                                <div className="flex-1 h-0.5 bg-gray-300 mx-2 sm:mx-4"></div>

                                {/* Step 2 - Choose Schedule */}
                                <div className="flex items-center justify-center">
                                    <div
                                        className="w-6 h-6 sm:w-6 sm:h-6 md:w-8 md:h-8 bg-gray-300 text-gray-600 rounded-full flex items-center justify-center text-xs sm:text-sm flex-shrink-0">
                                        2
                                    </div>
                                    {/* Text label - hidden on mobile */}
                                    <Typography variant="small"
                                                className="ml-1 sm:ml-2 text-gray-500 text-xs sm:text-sm whitespace-nowrap hidden sm:block">
                                        Schedule
                                    </Typography>
                                </div>

                                {/* Connector line 2 */}
                                <div className="flex-1 h-0.5 bg-gray-300 mx-2 sm:mx-4"></div>

                                {/* Step 3 - Car Information */}
                                <div className="flex items-center justify-center">
                                    <div
                                        className="w-6 h-6 sm:w-6 sm:h-6 md:w-8 md:h-8 bg-gray-300 text-gray-600 rounded-full flex items-center justify-center text-xs sm:text-sm flex-shrink-0">
                                        3
                                    </div>
                                    {/* Text label - hidden on mobile */}
                                    <Typography variant="small"
                                                className="ml-1 sm:ml-2 text-gray-500 text-xs sm:text-sm whitespace-nowrap hidden sm:block">
                                        Car
                                    </Typography>
                                </div>

                                {/* Connector line 3 */}
                                <div className="flex-1 h-0.5 bg-gray-300 mx-2 sm:mx-4"></div>

                                {/* Step 4 - Contact Information */}
                                <div className="flex items-center justify-center">
                                    <div
                                        className="w-6 h-6 sm:w-6 sm:h-6 md:w-8 md:h-8 bg-gray-300 text-gray-600 rounded-full flex items-center justify-center text-xs sm:text-sm flex-shrink-0">
                                        4
                                    </div>
                                    {/* Text label - hidden on mobile */}
                                    <Typography variant="small"
                                                className="ml-1 sm:ml-2 text-gray-500 text-xs sm:text-sm whitespace-nowrap hidden sm:block">
                                        Contact
                                    </Typography>
                                </div>

                                {/* Connector line 4 */}
                                <div className="flex-1 h-0.5 bg-gray-300 mx-2 sm:mx-4"></div>

                                {/* Step 5 - Complete */}
                                <div className="flex items-center justify-center">
                                    <div
                                        className="w-6 h-6 sm:w-6 sm:h-6 md:w-8 md:h-8 bg-gray-300 text-gray-600 rounded-full flex items-center justify-center text-xs sm:text-sm flex-shrink-0">
                                        5
                                    </div>
                                    {/* Text label - hidden on mobile */}
                                    <Typography variant="small"
                                                className="ml-1 sm:ml-2 text-gray-500 text-xs sm:text-sm whitespace-nowrap hidden sm:block">
                                        Complete
                                    </Typography>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="flex flex-col lg:flex-row gap-6 lg:gap-8 justify-center">
                        {/* Enhanced Service Selection Section */}
                        <div className="flex-1 max-w-5xl">
                            <Card className="border-0 shadow-xl bg-white/80 backdrop-blur-sm">
                                <CardBody className="p-4 sm:p-6 lg:p-8">
                                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">
                                        {/* Service Selection */}
                                        <div className="lg:col-span-2">
                                            <div className="mb-6 sm:mb-8">
                                                <div className="flex items-center gap-2 mb-2">
                                                    <Wrench className="w-5 h-5 sm:w-6 sm:h-6 text-blue-600"/>
                                                    <Typography variant="h5" color="blue-gray"
                                                                className="font-bold text-lg sm:text-xl lg:text-2xl">
                                                        Available Services
                                                    </Typography>
                                                </div>
                                                {/*<Typography variant="paragraph" color="gray"*/}
                                                {/*            className="mb-4 sm:mb-6 text-base sm:text-lg">*/}
                                                {/*    Click to select the services you need. Multiple selections allowed.*/}
                                                {/*</Typography>*/}
                                            </div>

                                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                                                {serviceList?.map((service) => {
                                                    const isSelected = selectedServiceList.some(selected => selected.id === service.id);
                                                    return (
                                                        <div key={service.id} className="relative">
                                                            <input
                                                                type="checkbox"
                                                                id={service.id}
                                                                value={JSON.stringify(service)}
                                                                onChange={ServiceListHandler}
                                                                name="serviceList"
                                                                className="hidden"
                                                                checked={isSelected}
                                                            />
                                                            <label
                                                                htmlFor={service.id}
                                                                className={`group relative flex items-center justify-between w-full h-24 sm:h-28 lg:h-32 p-4 sm:p-5 lg:p-6 text-gray-700 bg-white border-2 rounded-xl cursor-pointer transition-all duration-300 hover:bg-gray-50 hover:border-gray-300 hover:shadow-md transform hover:-translate-y-1 active:scale-95 ${
                                                                    isSelected
                                                                        ? 'border-blue-500 bg-blue-50 shadow-md'
                                                                        : 'border-gray-200'
                                                                }`}
                                                            >
                                                                <div
                                                                    className="flex items-center gap-3 sm:gap-4 w-full min-w-0">
                                                                    {/* Service icon */}
                                                                    <div
                                                                        className={`w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br rounded-full flex items-center justify-center transition-all duration-300 flex-shrink-0 ${
                                                                            isSelected
                                                                                ? 'from-blue-500 to-blue-600'
                                                                                : 'from-blue-100 to-blue-200 group-hover:from-blue-200 group-hover:to-blue-300'
                                                                        }`}>
                                                                        <Wrench
                                                                            className={`w-5 h-5 sm:w-6 sm:h-6 transition-colors duration-300 ${
                                                                                isSelected ? 'text-white' : 'text-blue-600'
                                                                            }`}/>
                                                                    </div>
                                                                    <div className="flex-1 min-w-0 overflow-hidden">
                                                                        <Typography variant="h6"
                                                                                    className="font-semibold mb-1 text-base sm:text-lg lg:text-xl leading-tight">
                                                                            <div className="line-clamp-2">
                                                                                <div>{service.name}</div>
                                                                                {service.description && (
                                                                                    <div
                                                                                        className="text-md sm:text-md text-gray-600 font-normal mt-0.5">
                                                                                        {service.description}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </Typography>
                                                                        {/*<Typography variant="small" color="gray"*/}
                                                                        {/*            className="text-sm sm:text-base">*/}
                                                                        {/*    {isSelected ? 'Selected' : 'Tap to select'}*/}
                                                                        {/*</Typography>*/}
                                                                    </div>
                                                                </div>

                                                                {/* Enhanced Checkmark indicator */}
                                                                <div
                                                                    className={`absolute top-2 sm:top-3 right-2 sm:right-3 w-5 h-5 sm:w-6 sm:h-6 rounded-full border-2 transition-all duration-300 flex items-center justify-center flex-shrink-0 ${
                                                                        isSelected
                                                                            ? 'bg-green-500 border-green-500 scale-110'
                                                                            : 'bg-white border-gray-300'
                                                                    }`}>
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        fill="none"
                                                                        viewBox="0 0 24 24"
                                                                        strokeWidth={3}
                                                                        stroke="currentColor"
                                                                        className={`w-3 h-3 sm:w-4 sm:h-4 text-white transition-all duration-300 ${
                                                                            isSelected ? 'opacity-100 scale-100' : 'opacity-0 scale-75'
                                                                        }`}
                                                                    >
                                                                        <path
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                            d="M4.5 12.75l6 6 9-13.5"
                                                                        />
                                                                    </svg>
                                                                </div>
                                                            </label>
                                                        </div>
                                                    );
                                                })}
                                            </div>

                                            {/* Enhanced memo section for ETC service */}
                                            {isEtcServiceSelected && (
                                                <div
                                                    className="mt-6 sm:mt-8 p-4 sm:p-6 bg-blue-50 border border-blue-200 rounded-xl">
                                                    <div className="mb-4">
                                                        <div className="flex items-center gap-2 mb-2">
                                                            <FileText className="w-4 h-4 sm:w-5 sm:h-5 text-blue-600"/>
                                                            <Typography variant="h6" color="blue-gray"
                                                                        className="font-semibold text-lg sm:text-xl">
                                                                Service Details
                                                            </Typography>
                                                        </div>
                                                        <Typography variant="small" color="gray"
                                                                    className="text-base sm:text-lg">
                                                            Please describe the service you need in detail.
                                                        </Typography>
                                                    </div>
                                                    <Textarea
                                                        maxLength="250"
                                                        value={selectedMemo}
                                                        onChange={(e) => memoHandler(e)}
                                                        rows="4"
                                                        className="w-full bg-white border-blue-200 focus:border-blue-500 text-base sm:text-lg"
                                                        placeholder="e.g., Engine making noise, brake issues, etc..."
                                                    />
                                                    <div
                                                        className="flex flex-col sm:flex-row sm:justify-between sm:items-center mt-2 gap-2">
                                                        <div className="flex items-center gap-1">
                                                            <AlertTriangle
                                                                className="w-3 h-3 sm:w-4 sm:h-4 text-orange-500"/>
                                                            <Typography variant="small" color="orange"
                                                                        className="font-medium text-sm sm:text-base">
                                                                Additional inspection fees may apply
                                                            </Typography>
                                                        </div>
                                                        <Typography variant="small" color="gray"
                                                                    className="text-sm sm:text-base">
                                                            {count}/250
                                                        </Typography>
                                                    </div>
                                                </div>
                                            )}

                                            {/* Mobile Next Button */}
                                            <MobileNextButton
                                                link="/schedule"
                                                enabled={selectedServiceList.length > 0}
                                                buttonText="Next Step →"
                                                disabledText="Please select services"
                                            />
                                        </div>

                                        {/* Enhanced Summary Panel */}
                                        <div className="lg:col-span-1 order-first lg:order-last hidden lg:block">
                                            <SummaryPanel
                                                link={"/schedule"}
                                                branch={branch}
                                                selectedServiceList={selectedServiceList}
                                                enabled={selectedServiceList && selectedServiceList.length > 0}
                                            />
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>
        </>
    );
}

export default Services;
